import React from 'react'
import { CircularProgress, Box, Grid } from '@material-ui/core';
import GovLogo from '../../assets/giriwawe_logo.png';

const AppLoading = () => {
  return (
		<Grid
			container
			direction='column'
			alignItems='center'
			justifyContent='center'
			style={{ minHeight: '100vh' }}
		>
			<Grid item>
				<Box position='relative' display='inline-flex'>
					{/* <CircularProgress size={130} /> */}
					<Box
						top={0}
						left={0}
						bottom={0}
						right={0}
						position='absolute'
						display='flex'
						alignItems='center'
						justifyContent='center'
						className='logo-spinner'
					>
						<img src={GovLogo} alt='BRD logo' width={100} />
					</Box>
				</Box>
			</Grid>
			{/* <Grid item>Loading...</Grid> */}
		</Grid>
	);
}

export default AppLoading
